<script>
import { usePageStore } from "@voix/store/pageStore";
import { useSliceStore } from "@voix/store/sliceStore";
import { v4 as uuidv4 } from "uuid";
import { defineComponent, ref } from "vue";
import AddSliceOptions from "../slices/AddSliceOptions.vue";
export default defineComponent({
  components: {
    AddSliceOptions
  },
  props: {
    addTo: {
      type: [String, Number],
      default: null
    },
    theSlot: {
      type: Object,
      default: () => ({ name: "default", allowedElements: [] })
    }
  },
  emits: ["close"],
  setup(props, ctx) {
    const pageStore = usePageStore();
    const sliceStore = useSliceStore();
    const showSliceSelector = ref(false);
    const selectedSlice = ref(null);
    const selectSlice = (sliceComponentName) => {
      selectedSlice.value = sliceComponentName;
    };
    const selectGroupSlice = () => {
      selectedSlice.value = "group";
    };
    const deselectSlice = () => {
      selectedSlice.value = null;
    };
    const addSliceToCurrentPage = () => {
      const component = selectedSlice.value;
      if (!component)
        return;
      const addToString = props.addTo ? props.addTo.toString() : null;
      if (component === "group") {
        const newGroup = {
          id: uuidv4(),
          label: "Group",
          enabled: 1,
          hydration_mode: "load",
          xp_status: "approved",
          type: "group",
          elements: [],
          properties: {
            dom_id: "",
            settings: [{ breakpoint: "default", padding: {}, margin: {}, contain: true }]
          },
          administration: {
            gui: { open: false, el: null },
            permissions: []
          }
        };
        pageStore.addElement(newGroup, addToString);
        showSliceSelector.value = false;
        return;
      }
      const newSlice = sliceStore.buildSliceDataFromSliceConfig(
        component,
        props.theSlot.name
      );
      if (newSlice) {
        pageStore.addElement(newSlice, addToString);
        showSliceSelector.value = false;
        ctx.emit("close");
      }
    };
    const requestCancel = () => {
      ctx.emit("close");
      showSliceSelector.value = false;
    };
    return {
      showSliceSelector,
      selectGroupSlice,
      selectSlice,
      deselectSlice,
      addSliceToCurrentPage,
      requestCancel
    };
  }
});
</script>

<template>
  <div class="relative text-xs">
    <div @click="showSliceSelector = !showSliceSelector">
      <slot />
    </div>

    <div
      v-if="showSliceSelector"
      class="fixed bottom-0 mb-4 ml-3 left-0 w-[900px] h-[90vh] translate-x-[275px] shadow-lg shadow-gray-400/30 bg-white border-l border-gray-200"
    >
      <div class="absolute inset-0 overflow-y-scroll px-6 py-2 pb-24 text-gray-700">
        <AddSliceOptions
          :allowed-elements="theSlot.allowedElements"
          @deselect="deselectSlice"
          @select="selectSlice"
          @select-group-slice="selectGroupSlice"
        />
      </div>

      <div
        class="absolute z-50 left-0 right-0 bottom-0 flex justify-start p-4 bg-gray-50 border-t border-gray-100"
      >
        <div class="max-w-sm w-full flex space-x-2">
          <button
            class="voix-admin-bg text-white px-3 py-2 rounded-full w-full"
            @click="addSliceToCurrentPage"
          >
            Add Slice
          </button>
          <button
            class="bg-gray-200 px-3 py-2 rounded-full w-full voix-admin-text"
            @click="requestCancel"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
